import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#00a088',
      light: '#7fcfc1',
      dark: '#0b4a41',
      contrastText: '#fff'
    }
  }
});
